import React, { CSSProperties, FunctionComponent } from 'react';
import { IVideoDataWidget } from '../../../../models/campaign-pages/widgets/video/video-data.model';
import styles from './video-component.module.scss';

export type VideoProps = {
  video: IVideoDataWidget;
  isContainerFullHeight?: boolean;
};

export const Video: FunctionComponent<VideoProps> = (props: VideoProps) => {
  return (
    <div
      className={`${styles['video-container']}  ${styles['desktop-horiz-alignment-' + props.video.videoHorizontalAlignment?.desktop]} ${
        styles['desktop-vert-alignment-' + props.video.videoVerticalAlignment?.desktop]
      } ${styles['mobile-vert-alignment-' + props.video.videoVerticalAlignment?.mobile]}`}
      style={{ '--container-height': props.isContainerFullHeight ? '100%' : 'auto' } as CSSProperties}>
      {props.video?.videoUrl && (
        <div
          className={styles['video-wrapper']}
          style={
            {
              //video width percentage for tablet+
              '--desktop-video-width-percentage': props.video.width ?? '100%',
            } as CSSProperties
          }>
          <iframe
            name={props.video.name ?? ''}
            title={props.video.description ?? ''}
            className={styles.video}
            src={props.video.videoUrl}
            allow='autoplay; encrypted-media'
            frameBorder='0'></iframe>
        </div>
      )}
    </div>
  );
};

Video.defaultProps = {
  isContainerFullHeight: true,
};

export default Video;
